import * as RoleType from "../user/RoleType";
import {addPrefix} from "../../utils/UriUtil";
import {DAUMBLOG} from "../Service"

// 메뉴 그룹
// 매뉴의 링크, 이름, 필요 권한을 기입

const TistoryMenus = [
  { group: 'home', to: "/", name: "블로그관리 홈", requireRole: RoleType.WRITER},
  { group: 'content', to: "/posts", name: "글 관리", requireRole: RoleType.WRITER},
  { group: 'content', to: "/pages", name: "페이지 관리", requireRole: RoleType.WRITER},
  { group: 'content', to: "/category", name: "카테고리 관리", requireRole: RoleType.EDITOR},
  { group: 'content', to: "/notices", name: "공지 관리", requireRole: RoleType.WRITER},
  { group: 'content', to: "/templates", name: "서식 관리", requireRole: RoleType.WRITER},
  { group: 'content', to: "/keywords", name: "키워드 관리", requireRole: RoleType.WRITER},
  { group: 'content', to: "/setting/contents", name: "설정", requireRole: RoleType.MANAGER},
  { group: 'comment', to: "/comments", name: "댓글 관리", requireRole: RoleType.WRITER},
  { group: 'comment', to: "/comments/trash", name: "댓글 휴지통 관리", requireRole: RoleType.WRITER, hideOneDepth : true},
  { group: 'comment', to: "/guestbook", name: "방명록 관리", requireRole: RoleType.WRITER},
  { group: 'comment', to: "/guestbook/trash", name: "방명록 휴지통 관리", requireRole: RoleType.WRITER, hideOneDepth : true},
  { group: 'comment', to: "/setting/comments", name: "설정", requireRole: RoleType.MANAGER},
  { group: 'stat', to: "/statistics/blog", name: "방문 통계", requireRole: RoleType.WRITER},
  { group: 'stat', to: "/statistics/referrer", name: "유입 경로", requireRole: RoleType.WRITER},

  { group: 'revenue', to: "/revenue/adfit", name: "애드핏 관리", requireRole: RoleType.MANAGER},
  { group: 'revenue', to: "/revenue/adsense", name: "애드센스 관리", requireRole: RoleType.MANAGER},

  { group: 'design', to: "/design/skin", name: "스킨 변경", requireRole: RoleType.MANAGER},
  { group: 'design', to: addPrefix("/manage/design/skin/edit"), name: "스킨 편집", external: true, requireRole: RoleType.MANAGER},
  { group: 'design', to: "/design/sidebar", name: "사이드바", requireRole: RoleType.MANAGER},
  { group: 'design', to: "/design/menu", name: "메뉴", requireRole: RoleType.MANAGER},
  { group: 'design', to: "/design/mobile", name: "모바일", requireRole: RoleType.MANAGER},
  { group: 'design', to: "/design/setting", name: "메뉴바/구독 설정", requireRole: RoleType.MANAGER},
  { group: 'plugin', to: "/plugins", name: "플러그인", requireRole: RoleType.MANAGER},
  { group: 'link', to: "/link/my", name: "나의 링크", requireRole: RoleType.MANAGER},
  { group: 'setting', to: "/setting/blog", name: "블로그", requireRole: RoleType.MANAGER},
  { group: 'setting', to: "/setting/blog/data", name: "데이터 관리", requireRole: RoleType.OWNER, hideOneDepth : true},
  { group: 'setting', to: "/teamblog", name: "팀블로그", requireRole: RoleType.WRITER},
  { group: null, to: "/design/skin/add", name: "꾸미기 > 스킨등록", requireRole: RoleType.MANAGER},
  { group: null, to: "/design/skin/archive", name: "꾸미기 > 스킨보관함", requireRole: RoleType.MANAGER},
];

const DaumBlogMenus = [
  { group: 'home', to: "/", name: "블로그관리 홈", requireRole: RoleType.WRITER},

  { group: 'content', to: "/posts", name: "글 관리", requireRole: RoleType.WRITER},
  { group: 'content', to: "/pages", name: "페이지 관리", requireRole: RoleType.WRITER},
  { group: 'content', to: "/category", name: "카테고리 관리", requireRole: RoleType.EDITOR},
  { group: 'content', to: "/templates", name: "서식 관리", requireRole: RoleType.WRITER},
  { group: 'content', to: "/setting/contents", name: "설정", requireRole: RoleType.MANAGER},

  { group: 'comment', to: "/comments", name: "댓글 관리", requireRole: RoleType.WRITER},
  { group: 'comment', to: "/comments/trash", name: "댓글 휴지통 관리", requireRole: RoleType.WRITER, hideOneDepth : true},
  { group: 'comment', to: "/guestbook", name: "방명록 관리", requireRole: RoleType.WRITER},
  { group: 'comment', to: "/guestbook/trash", name: "방명록 휴지통 관리", requireRole: RoleType.WRITER, hideOneDepth : true},
  { group: 'comment', to: "/setting/comments", name: "설정", requireRole: RoleType.MANAGER},

  { group: 'stat', to: "/statistics/blog", name: "방문 통계", requireRole: RoleType.WRITER},
  { group: 'stat', to: "/statistics/referrer", name: "유입 경로", requireRole: RoleType.WRITER},

  { group: 'design', to: "/design/skin", name: "스킨 변경", requireRole: RoleType.MANAGER},
  { group: 'design', to: addPrefix("/manage/design/skin/edit"), name: "스킨 편집", external: true, requireRole: RoleType.MANAGER},
  { group: 'design', to: "/design/sidebar", name: "사이드바", requireRole: RoleType.MANAGER},
  { group: 'design', to: "/design/menu", name: "메뉴", requireRole: RoleType.MANAGER},
  { group: 'design', to: "/design/mobile", name: "모바일", requireRole: RoleType.MANAGER},

  { group: 'plugin', to: "/plugins", name: "플러그인", requireRole: RoleType.MANAGER},

  { group: 'setting', to: "/setting/blog", name: "블로그", requireRole: RoleType.MANAGER},
  { group: 'setting', to: "/setting/blog/data", name: "데이터 관리", requireRole: RoleType.OWNER, hideOneDepth : true}
];


export const menus = window.Config.service === DAUMBLOG ? DaumBlogMenus : TistoryMenus

function filterMenus(groupName) {
  return menus.filter(menu => menu.group === groupName && !menu.hideOneDepth)
}

export default {
    home : filterMenus('home'),
    content : filterMenus('content'),
    comment : filterMenus('comment'),
    stat: filterMenus('stat'),
    revenue: filterMenus('revenue'),
    design : filterMenus('design'),
    plugin : filterMenus('plugin'),
    link : filterMenus('link'),
    setting : filterMenus('setting'),
};
